import { Button } from "@/components/ui/button";
import {
  Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger,
} from "@/components/ui/dialog";

/**
 * Create programme (Damien 31 Oct) for a customer with no plan. The database step that starts one from here does
 * not exist yet (Zach) and the create flow waits on the canvas v3.x sign-off, so the button only says so and what
 * to do meanwhile. It changes nothing.
 */
export function CreateProgramme({ first }: { first: string }) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button data-nonmutating>Create programme</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="pr-6">Create programme: coming soon</DialogTitle>
          <DialogDescription>
            {first} has no programme yet, and starting one from here is still being built.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2 text-sm">
          <p>Until then:</p>
          <ul className="list-disc space-y-1 pl-5">
            <li>Reply to her in Intercom and ask her to finish her first check-in in the app. Her programme starts from her answers.</li>
            <li>If she is waiting on you, mark it handled once you have replied.</li>
          </ul>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline" data-nonmutating>Got it</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
